import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { useCallback, useContext, useState } from 'react';
import { useLocalStorage } from './storage/useLocalStorage';
import { MultiBetViewMode } from './useGlobalData';
export enum GAME_INFO_BUTTON {
    SWITCH_TABLE,
    TABLE_INFO,
    BET_LIMIT,
    BET_STATISTICS,
    NO_COMMISSION,
    FAVORITE,
    GOOD_ROAD,
    ROUL_SWITCH_BET_MODE,
    MULTI_BET_FILTER,
    BET_INFO,
    BET_AREA_EXTEND,
    GIFT,
    ULTRA_ROUL_SWITCH_BET_MODE,
}
export const useGameInfoButtonController = () => {
    const [isSwitchTableOpen, setIsSwitchTableOpen] = useState(false);
    const [isTableInfoOpen, setIsTableInfoOpen] = useState(false);
    const [isBetInfoOpen, setIsBetInfoOpen] = useState(false);
    const [isBetLimitOpen, setIsBetLimitOpen] = useState(false);
    const [isBetStatisticsOpen, setIsBetStatisticsOpen] = useState(false);
    const [isNoCommissionOpen, setIsNoCommissionOpen] = useState(false);
    const [isFavoriteOpen, setIsFavoriteOpen] = useState(false);
    const [isGoodRoadOpen, setIsGoodRoadOpen] = useState(false);
    const [isRoulRacetrackBetMode, setIsRoulRacetrackBetMode] = useState(false);
    const [isUltraRoulRacetrackBetMode, setIsUltraRoulRacetrackBetMode] =
        useState(false);
    const [isMultiBetViewOpen, setIsMultiBetViewOpen] = useState(true);
    const [isGiftOpen, setIsGiftOpen] = useState(false);
    const [multiBetView, setMultiBetView] = useLocalStorage(
        'multi-bet-view',
        MultiBetViewMode.FullRoad
    );
    const { isMobile } = useContext(ScreenContext);
    const [isBetAreaExtend, setIsBetAreaExtend] = useState(false);
    const [isBetAreaExtendEnable, setIsBetAreaExtendEnable] =
        useState(isMobile);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const toggleNC = useCallback(() => {
        playButtonAudio();
        setIsNoCommissionOpen(!isNoCommissionOpen);
    }, [isNoCommissionOpen, playButtonAudio]);
    const closeAll = useCallback(() => {
        setIsSwitchTableOpen(false);
        setIsTableInfoOpen(false);
        setIsBetInfoOpen(false);
        setIsBetLimitOpen(false);
        setIsBetStatisticsOpen(false);
        setIsGiftOpen(false);
    }, []);
    const open = useCallback(
        (buttonType: GAME_INFO_BUTTON) => {
            playButtonAudio();
            closeAll();
            switch (buttonType) {
                case GAME_INFO_BUTTON.SWITCH_TABLE:
                    setIsSwitchTableOpen(true);
                    break;
                case GAME_INFO_BUTTON.TABLE_INFO:
                    setIsTableInfoOpen(true);
                    break;
                case GAME_INFO_BUTTON.BET_INFO:
                    setIsBetInfoOpen(true);
                    break;
                case GAME_INFO_BUTTON.BET_LIMIT:
                    setIsBetLimitOpen(true);
                    break;
                // case GAME_INFO_BUTTON.BET_STATISTICS:
                //     setIsBetStatisticsOpen(true);
                //     break;
                case GAME_INFO_BUTTON.GIFT:
                    setIsGiftOpen(true);
                    break;
                case GAME_INFO_BUTTON.ROUL_SWITCH_BET_MODE:
                    setIsRoulRacetrackBetMode(!isRoulRacetrackBetMode);
                    break;
                case GAME_INFO_BUTTON.ULTRA_ROUL_SWITCH_BET_MODE:
                    setIsUltraRoulRacetrackBetMode(
                        !isUltraRoulRacetrackBetMode
                    );
                    break;
                case GAME_INFO_BUTTON.BET_AREA_EXTEND:
                    setIsBetAreaExtendEnable(!isBetAreaExtendEnable);
                    break;
            }
        },
        [
            isRoulRacetrackBetMode,
            isUltraRoulRacetrackBetMode,
            isBetAreaExtendEnable,
            playButtonAudio,
        ]
    );
    return {
        open,
        closeAll,
        isSwitchTableOpen,
        isTableInfoOpen,
        isBetInfoOpen,
        isBetLimitOpen,
        isBetStatisticsOpen,
        // NC
        toggleNC,
        isNoCommissionOpen,
        setIsFavoriteOpen,
        isFavoriteOpen,
        setIsGoodRoadOpen,
        isGoodRoadOpen,
        // Roulette
        isRoulRacetrackBetMode,
        setIsRoulRacetrackBetMode,
        // UltraRoulette
        isUltraRoulRacetrackBetMode,
        setIsUltraRoulRacetrackBetMode,
        //multibet
        isMultiBetViewOpen,
        setIsMultiBetViewOpen,
        multiBetView,
        setMultiBetView,
        setIsBetInfoOpen,
        isBetAreaExtend,
        setIsBetAreaExtend,
        isBetAreaExtendEnable,
        setIsBetAreaExtendEnable,
        isGiftOpen,
        setIsGiftOpen,
    };
};
export type useGameInfoButtonControllerState = ReturnType<
    typeof useGameInfoButtonController
>;
